/**
 * Content Security Policy Configuration
 * ✅ SECURITY: Environment-specific CSP settings
 */
// Development CSP - Permissive for local testing
export const developmentCSP = {
    defaultSrc: ["'self'", "data:", "blob:"],
    connectSrc: [
        "'self'",
        "http://localhost:*",
        "ws://localhost:*",
        "wss://localhost:*",
        "http://127.0.0.1:*"
    ],
    scriptSrc: ["'self'", "'unsafe-inline'", "'unsafe-eval'"],
    styleSrc: ["'self'", "'unsafe-inline'", "https://fonts.googleapis.com"],
    fontSrc: ["'self'", "https://fonts.gstatic.com"],
    imgSrc: [
        "'self'",
        "data:",
        "blob:",
        "http://localhost:*",
        "https://eckpunkt.app",
        "https://*.eckpunkt.app",
    ]
};
// Production CSP - Strict security
export const productionCSP = {
    defaultSrc: ["'self'", "data:", "blob:"],
    connectSrc: [
        "'self'",
        "https://eckpunkt.app",
        "https://*.eckpunkt.app",
        "https://daluigi.app",
        "https://*.daluigi.app",
        "https://tasti-o.app",
        "https://*.tasti-o.app"
    ],
    scriptSrc: ["'self'", "'unsafe-inline'"],
    styleSrc: ["'self'", "'unsafe-inline'", "https://fonts.googleapis.com"],
    fontSrc: ["'self'", "https://fonts.gstatic.com"],
    imgSrc: [
        "'self'",
        "data:",
        "blob:",
        "https://eckpunkt.app",
        "https://*.eckpunkt.app",
        "https://daluigi.app",
        "https://*.daluigi.app",
        "https://tasti-o.app",
        "https://*.tasti-o.app"
    ]
};
// Convert CSP config to string
export function cspConfigToString(config) {
    const directives = [
        `default-src ${config.defaultSrc.join(' ')}`,
        `connect-src ${config.connectSrc.join(' ')}`,
        `script-src ${config.scriptSrc.join(' ')}`,
        `style-src ${config.styleSrc.join(' ')}`,
        `font-src ${config.fontSrc.join(' ')}`,
        `img-src ${config.imgSrc.join(' ')}`
    ];
    return directives.join('; ') + ';';
}
// Get appropriate CSP for current environment
export function getEnvironmentCSP() {
    const isProduction = process.env.NODE_ENV === 'production' ||
        (typeof window !== 'undefined' &&
            window.location.hostname !== 'localhost' &&
            window.location.hostname !== '127.0.0.1');
    const config = isProduction ? productionCSP : developmentCSP;
    return cspConfigToString(config);
}
// Apply CSP dynamically (for client-side usage)
export function applyCSP() {
    if (typeof document === 'undefined')
        return;
    const cspString = getEnvironmentCSP();
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Security-Policy');
    meta.setAttribute('content', cspString);
    document.head.appendChild(meta);
    const isDev = process.env.NODE_ENV !== 'production';
    console.log(`🔐 CSP Applied: ${isDev ? 'Development' : 'Production'} mode`);
    if (isDev) {
        console.log('🔧 Development CSP allows localhost connections');
        console.log('📝 CSP Content:', cspString);
    }
}
